/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free aspect ratio calculator. Reduce a width and height to a clean ratio like 16:9, and resize while keeping the ratio. Runs in your browser.`)
};

const es_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora gratuita de relación de aspecto. Reduce un ancho y alto a una relación limpia como 16:9, y redimensiona manteniendo la relación. Se ejecuta en tu navegador.`)
};

const de_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Seitenverhältnis-Rechner. Kürzt eine Breite und Höhe auf ein sauberes Verhältnis wie 16:9 und ändert die Größe unter Beibehaltung des Verhältnisses. Läuft direkt in deinem Browser.`)
};

const nl_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis beeldverhouding calculator. Vereenvoudig een breedte en hoogte tot een schone verhouding zoals 16:9 en pas de grootte aan terwijl je de verhouding behoudt. Draait in je browser.`)
};

const fr_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculateur de rapport d'aspect gratuit. Réduisez une largeur et une hauteur à un rapport parfait comme 16:9, et redimensionnez en gardant le rapport. Fonctionne dans votre navigateur.`)
};

const it_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calcolatore gratuito del rapporto di aspetto. Riduci una larghezza e un'altezza a un rapporto pulito come 16:9 e ridimensiona mantenendo il rapporto. Funziona nel tuo browser.`)
};

const pt_br2_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de taxa de aspecto gratuita. Reduza uma largura e altura para uma taxa limpa como 16:9 e redimensione mantendo a taxa. Funciona no seu navegador.`)
};

const pt_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calculadora de proporção de aspecto gratuita. Reduza uma largura e altura a uma proporção limpa como 16:9 e redimensione mantendo a proporção. Funciona no seu navegador.`)
};

const ja_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のアスペクト比計算機。幅と高さを16:9などのクリーンな比率に減らし、その比率を保ったままリサイズできます。ブラウザで実行されます。`)
};

const zh_ar_tool_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费的宽高比计算器。将宽度和高度化简为16:9这样简洁的比例,并在保持比例的同时调整大小。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ar_tool_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ar_tool_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ar_tool_description", locale)
	if (locale === "en") return en_ar_tool_description(inputs)
	if (locale === "es") return es_ar_tool_description(inputs)
	if (locale === "de") return de_ar_tool_description(inputs)
	if (locale === "nl") return nl_ar_tool_description(inputs)
	if (locale === "fr") return fr_ar_tool_description(inputs)
	if (locale === "it") return it_ar_tool_description(inputs)
	if (locale === "pt-BR") return pt_br2_ar_tool_description(inputs)
	if (locale === "pt") return pt_ar_tool_description(inputs)
	if (locale === "ja") return ja_ar_tool_description(inputs)
	return zh_ar_tool_description(inputs)
};